function normalizeDate(value) {
  if (!value) return null

  const raw = String(value).trim()

  // Date-only values from backend (YYYY-MM-DD) should be interpreted in local time
  // to avoid timezone shifts like displaying 18:00 for midnight UTC.
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    const [year, month, day] = raw.split('-').map(Number)
    const parsedLocal = new Date(year, month - 1, day, 0, 0, 0)
    return Number.isNaN(parsedLocal.getTime()) ? null : parsedLocal
  }

  const parsed = new Date(raw.includes('T') ? raw : raw.replace(' ', 'T'))
  return Number.isNaN(parsed.getTime()) ? null : parsed
}

function toTwoDigits(value) {
  return `${value}`.padStart(2, '0')
}

export default function useDateFormatter() {
  function parseDateFromApi(value) {
    const text = String(value || '').substring(0, 10)
    if (!text) return null

    const date = new Date(`${text}T00:00:00`)
    if (Number.isNaN(date.getTime())) return null

    return date
  }

  function formatDateForApi(value) {
    if (!value) return ''

    if (typeof value === 'string') {
      return value.substring(0, 10)
    }

    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return ''

    const yyyy = date.getFullYear()
    const mm = toTwoDigits(date.getMonth() + 1)
    const dd = toTwoDigits(date.getDate())
    return `${yyyy}-${mm}-${dd}`
  }

  function formatFullDate(value) {
    const parsed = normalizeDate(value)
    if (!parsed) return ''

    const formatter = new Intl.DateTimeFormat('es-MX', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
      timeZone: 'America/Mexico_City'
    })

    const formatted = formatter.format(parsed)
    return formatted.charAt(0).toUpperCase() + formatted.slice(1)
  }

  function formatDate(value) {
    const parsed = normalizeDate(value)
    if (!parsed) return ''

    const dd = toTwoDigits(parsed.getDate())
    const mm = toTwoDigits(parsed.getMonth() + 1)
    const yyyy = parsed.getFullYear()
    return `${dd}/${mm}/${yyyy}`
  }

  function formatTime(value) {
    const parsed = normalizeDate(value)
    if (!parsed) return ''

    const hh = toTwoDigits(parsed.getHours())
    const min = toTwoDigits(parsed.getMinutes())
    return `${hh}:${min}`
  }

  function formatDateTime(value) {
    const date = formatDate(value)
    const time = formatTime(value)

    if (!date) return ''
    if (!time) return date

    return `${date} ${time}`
  }

  return {
    normalizeDate,
    parseDateFromApi,
    formatDateForApi,
    formatFullDate,
    formatDate,
    formatTime,
    formatDateTime
  }
}
